import { formatCurrency } from "@/utils/paymentUtils";

/** `duplicateOf` as process-extraction-jobs writes it into `finalizationError`. */
export interface DuplicateInfo {
  id?: string;
  vendor?: string | null;
  amount?: number | null;
  currency?: string | null;
  remittanceInformation?: string | null;
  /** Set for a Z-report that duplicates an existing sales report (FIN-1024). */
  reportDate?: string | null;
}

/** The translator for `consultantUpload.duplicate`. */
type DuplicateTranslator = (key: "zReport" | "of" | "unknownVendor" | "reference", values?: Record<string, string>) => string;

/** What the Rejected tab says a duplicate upload duplicates. */
export function describeDuplicate(info: DuplicateInfo, t: DuplicateTranslator): string {
  const amount = info.amount ? ` (${formatCurrency(info.amount, info.currency ?? undefined)})` : "";
  if (info.reportDate) return t("zReport", { date: info.reportDate, amount });
  // F1 (AC1/EC2, issue #904): labeled reference number when the original has one, else a
  // properly formatted currency amount — never the bare unformatted integer this replaces.
  const reference = info.remittanceInformation ? t("reference", { reference: info.remittanceInformation }) : amount;
  return t("of", { vendor: info.vendor ?? t("unknownVendor"), reference });
}
